import { DiscIcon as PhosphorDiscIcon } from "@phosphor-icons/react/dist/ssr/Disc";

import { createAppIcon } from "@/components/createAppIcon";

export const CompactDiscIcon = /* @__PURE__ */ createAppIcon(PhosphorDiscIcon);
